import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useApi } from '@tabeeb/modules/shared/utils/API'
import { AIQueryKeys } from '../queries'

const useNLPModel = ({ id, onError }: { id: number; onError: (error: unknown) => void }) => {
  const { aiServiceApi: api } = useApi()

  const { isLoading, data, error } = useQuery({
    queryKey: [AIQueryKeys.NLPModel, id],
    queryFn: () => api.nlpModels.getAsync(id),
  })

  useEffect(() => {
    if (error) onError(error)
  }, [error, onError])

  return { loading: isLoading, nlpModel: data }
}

export default useNLPModel
